import { render, staticRenderFns } from "./capabilities.vue?vue&type=template&id=14721b13&scoped=true&"
import script from "./capabilities.vue?vue&type=script&lang=js&"
export * from "./capabilities.vue?vue&type=script&lang=js&"
import style0 from "./capabilities.vue?vue&type=style&index=0&id=14721b13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14721b13",
  null
  
)

export default component.exports